import { TestData as MaalerTypeTestData } from "../../maaler-type/test/test-data";
import { DbMaalerAflaesning } from "../../model/db-maaler-aflaesning";
import { DbMaalerAflaesningMedNoter } from "../../model/db-maaler-aflaesning-med-noter";
import { MaalerAflaesningMedNoter } from "../../model/maaler-aflaesning-med-noter.model";
import { MaalerAflaesning } from "../../model/maaler-aflaesning.model";
import { MaalerType } from "../../model/maaler-type.model";

export class TestData {
    public static get maalerType1(): MaalerType {
        return MaalerTypeTestData.maalerType1;
    }

    public static get maalerType2(): MaalerType {
        return MaalerTypeTestData.maalerType2;
    }

    public static get alleMaalerTyper(): MaalerType[] {
        return MaalerTypeTestData.alleMaalerTyper;
    }

    public static get maalerAflaesning1(): MaalerAflaesning {
        return {
            maalerNr: { oprindelig: "MAALER 1", aktuel: "MAALER 1-1" },
            maalerTypeId: { oprindelig: 1, aktuel: 2 },
            taellevaerker: []
        };
    }

    public static get maalerAflaesning2(): MaalerAflaesningMedNoter {
        return {
            maalerNr: { oprindelig: "MAALER 2", aktuel: "MAALER 2-2" },
            maalerTypeId: { oprindelig: 1, aktuel: 2 },
            taellevaerker: [
                {
                    aflaesning: { oprindelig: 1, aktuel: 2 },
                    enhedType: "ENHED_TYPE 1",
                    historiskAflaesning: 0
                },
                {
                    aflaesning: { oprindelig: 4, aktuel: 5 },
                    enhedType: "ENHED_TYPE 2",
                    historiskAflaesning: 3
                }
            ],
            noter: []
        };
    }

    public static get dbMaalerAflaesning1(): DbMaalerAflaesning {
        return {
            maalerNr: { oprindelig: "MAALER 1", aktuel: "MAALER 1-1" },
            maalerTypeId: { oprindelig: 1, aktuel: 2 },
            taellevaerker: []
        };
    }

    public static get dbMaalerAflaesning2(): DbMaalerAflaesningMedNoter {
        return {
            maalerNr: { oprindelig: "MAALER 2", aktuel: "MAALER 2-2" },
            maalerTypeId: { oprindelig: 1, aktuel: 2 },
            taellevaerker: [
                {
                    aflaesning: { oprindelig: "1", aktuel: "2" },
                    enhedType: "ENHED_TYPE 1",
                    historiskAflaesning: "0"
                },
                {
                    aflaesning: { oprindelig: "4", aktuel: "5" },
                    enhedType: "ENHED_TYPE 2",
                    historiskAflaesning: "3"
                }
            ],
            noter: []
        };
    }
}
